import type { TimeProfileConfiguration, TimeProfileTimeBlock } from "./api";

export const timeProfileWeekdays = [
  { id: 1, short: "Mo", label: "Montag" },
  { id: 2, short: "Di", label: "Dienstag" },
  { id: 3, short: "Mi", label: "Mittwoch" },
  { id: 4, short: "Do", label: "Donnerstag" },
  { id: 5, short: "Fr", label: "Freitag" },
  { id: 6, short: "Sa", label: "Samstag" },
  { id: 7, short: "So", label: "Sonntag" },
] as const;

export function timeProfileMinutes(value: string) {
  const [hour, minute] = value.split(":").map(Number);
  return hour * 60 + minute;
}

export function timeProfileBlockCrossesMidnight(block: TimeProfileTimeBlock) {
  return timeProfileMinutes(block.end) < timeProfileMinutes(block.start);
}

export function timeProfileBlockEndsNextDay(block: TimeProfileTimeBlock) {
  return timeProfileBlockCrossesMidnight(block) && Boolean(block.ends_next_day);
}

export function timeProfileBlockSemanticsLabel(block: TimeProfileTimeBlock) {
  if (!timeProfileBlockCrossesMidnight(block)) return "";
  return timeProfileBlockEndsNextDay(block)
    ? "Endet am Folgetag"
    : `Kalendertag: 00:00–${block.end} + ${block.start}–24:00`;
}

export function timeProfileAveragePeriodLabel(block?: TimeProfileTimeBlock) {
  return block && timeProfileBlockEndsNextDay(block) ? "Starttag" : "Kalendertag";
}

export function defaultTimeProfileConfiguration(): TimeProfileConfiguration {
  return {
    allow_overlaps: false,
    weekday_groups: [
      { name: "Werktage", weekdays: [1, 2, 3, 4, 5] },
      { name: "Wochenende", weekdays: [6, 7] },
    ],
    time_blocks: [
      { name: "Morgen", start: "08:00", end: "12:00" },
      { name: "Mittag / Nachmittag", start: "12:00", end: "18:00" },
    ],
    metric: "average_per_calendar_day",
  };
}
